// @flow

// By default, most of the content in PinRepPresentation is set to
// pointer-events: "none" so we can overlay stuff over the top of the click
// handler and still allow clicks. BUT, this means we need to re-enable
// pointer-events for any controls that actually require mouse interaction
// (buttons, links, etc).

import React, { type Node } from 'react';

export default function enablePointerEvents(children: Node) {
  return (
    <div data-test-id="pointer-events-wrapper" style={{ pointerEvents: 'auto' }}>
      {children}
    </div>
  );
}
